import { PlusOutlined } from '@ant-design/icons'
import { message, Spin } from 'antd'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useRecoilValue } from 'recoil'
import { getCalendarWorkItems } from '../../../api/standalone.api'
import {
  scheduleBoardRefetchTrigger,
  standaloneScheduleViewUserId,
} from '../../../store/standaloneSchedule'
import { userState } from '../../../store/user'
import '../StandaloneSchedulePage.scss'
// import SectionHeader from '../ui/SectionHeader'
import SectionHeader from '../../../components/apos/SectionHeader'
import TaskColorChip from '../ui/TaskColorChip'

const ScheduleBoardSection = ({
  title,
  subtitle,
  buttonText,
  onOpenRoutinePopup,
  onOpenRoutineItemPopup,
  onOpenScheduledItemPopup,
  buttonText2,
  handleOpenScheduledPopup,
}) => {
  const user = useRecoilValue(userState)
  const viewUserId = useRecoilValue(standaloneScheduleViewUserId)
  const effectiveUserId = viewUserId ?? user?.id
  const scheduleBoardRefetch = useRecoilValue(scheduleBoardRefetchTrigger)
  const [currentDate, setCurrentDate] = useState(dayjs())
  const [tasks, setTasks] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const fetchCalendarTasks = async () => {
    if (!effectiveUserId) return

    setIsLoading(true)
    try {
      const year = currentDate.year()
      const month = currentDate.month() + 1 // dayjs month는 0-11
      // console.log('year::', year)
      // console.log('month::', month)
      const res = await getCalendarWorkItems(null, year, month, effectiveUserId)
      console.log('getCalendarWorkItems res::', res)
      if (res.status === 200) {
        setTasks(res.data || [])
      }
    } catch (error) {
      console.error('fetchCalendarTasks error::', error)
      message.error('달력 업무 조회에 실패했습니다.')
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchCalendarTasks()
  }, [effectiveUserId, currentDate.format('YYYY-MM'), scheduleBoardRefetch])

  // 현재 월의 달력 데이터 생성
  const getCalendarDays = () => {
    const startOfMonth = currentDate.startOf('month')
    const endOfMonth = currentDate.endOf('month')
    const startDate = startOfMonth.startOf('week') // 주의 시작 (일요일)
    const endDate = endOfMonth.endOf('week') // 주의 끝 (토요일)

    const days = []
    let currentDay = startDate

    while (currentDay.isBefore(endDate) || currentDay.isSame(endDate, 'day')) {
      days.push(currentDay)
      currentDay = currentDay.add(1, 'day')
    }

    return days
  }

  // 특정 날짜의 업무 가져오기
  const getTasksForDate = (date) => {
    if (!tasks || !Array.isArray(tasks)) return []
    return tasks.filter((task) => {
      if (!task.scheduledDate) return false
      const taskDate = dayjs(task.scheduledDate)
      return taskDate.isSame(date, 'day')
    })
  }

  const calendarDays = getCalendarDays()
  const weekDays = ['일', '월', '화', '수', '목', '금', '토']

  // const handlePrevMonth = () => {
  //   setCurrentDate(currentDate.subtract(1, 'month'))
  // }

  // const handleNextMonth = () => {
  //   setCurrentDate(currentDate.add(1, 'month'))
  // }

  return (
    <section className="standalone-schedule-container">
      <SectionHeader
        title={title}
        subtitle={subtitle}
        // 스케쥴
        buttonText={buttonText}
        onButtonClick={handleOpenScheduledPopup}
        // 루틴
        // buttonText2={buttonText2}
        // onButtonClick2={onOpenRoutinePopup}
      />

      <div className="schedule-calendar-wrapper">
        <Spin spinning={isLoading}>
          <div className="calendar-header">
            {/* <div className="calendar-nav-buttons">
              <button className="calendar-nav-button" onClick={handlePrevMonth}>
                {'<'}
              </button>
            </div> */}

            <div className="calendar-month-year">
              {currentDate.format('YYYY년 M월')}
            </div>

            <div style={{ position: 'absolute', right: 20 }}>
              <button className="register-button" onClick={onOpenRoutinePopup}>
                {buttonText2}
                <PlusOutlined />
              </button>
            </div>

            {/* <div className="calendar-nav-buttons">
              <button className="calendar-nav-button" onClick={handleNextMonth}>
                {'>'}
              </button>
            </div> */}
          </div>

          <div className="calendar-grid">
            {/* 요일 헤더 */}
            <div className="calendar-weekdays">
              {weekDays.map((day, index) => (
                <div
                  key={day}
                  className={`calendar-weekday ${index === 0 ? 'sunday' : ''}`}
                >
                  {day}
                </div>
              ))}
            </div>

            {/* 날짜 그리드 */}
            <div className="calendar-days">
              {calendarDays.map((date, index) => {
                const isCurrentMonth = date.month() === currentDate.month()
                const isToday = date.isSame(dayjs(), 'day')
                const isSunday = date.day() === 0
                const dayTasks = getTasksForDate(date)

                return (
                  <div
                    key={index}
                    className={`calendar-day ${!isCurrentMonth ? 'other-month' : ''} ${isToday ? 'today' : ''} ${isSunday ? 'sunday' : ''}`}
                  >
                    <div className="calendar-day-number">{date.date()}</div>
                    <div className="calendar-day-tasks">
                      {dayTasks.map((task, taskIndex) => {
                        const handleTaskClick = () => {
                          if (task.workType === 'SCHEDULED') {
                            onOpenScheduledItemPopup?.(task.id)
                          } else if (task.workType === 'ROUTINE') {
                            onOpenRoutineItemPopup?.(task.id)
                          }
                        }

                        return (
                          <div
                            key={taskIndex}
                            className="calendar-task-item"
                            onClick={handleTaskClick}
                          >
                            <TaskColorChip
                              color={task.colorCode || '#FFC700'}
                            />
                            <span className="calendar-task-text">
                              {task.title}
                            </span>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </Spin>
      </div>
    </section>
  )
}

export default ScheduleBoardSection
